module.exports = __webpack_public_path__ + "media/public/img/sponsors/Arival-Logo-White-24e1b4ff62ae9602ced73a5ec3a69842.jpg";